import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  initialCylinder,
  initial_filters,
} from '../models/cylinder_model.js';
import { getParamsUrl } from '../cylinders_utils.js';

export const useCylinderStore = defineStore('cylinderStore', {
  state: () => ({
    cylinder: { ...initialCylinder },
    cylinderFilters: { ...initial_filters },
    cylinderList: [],
    page: 1,
    validateCylinderFields: {
      CodigoCilindroTipo: true,
      CodigoDesarrollo: true,
      CantidadCilindros: true,
    },
  }),

  actions: {
    resetValidations() {
      // Resetear cada campo de validación al estado inicial
      Object.keys(this.validateCylinderFields).forEach((key) => {
        this.validateCylinderFields[key] = true;
      });
    },
    validarCampos() {
      this.validateCylinderFields.CodigoCilindroTipo = !!this.cylinder.CodigoCilindroTipo;
      this.validateCylinderFields.CodigoDesarrollo = !!this.cylinder.CodigoDesarrollo;
      this.validateCylinderFields.CantidadCilindros =
        this.cylinder.CantidadCilindros !== (null || undefined);

      return (
        this.validateCylinderFields.CodigoCilindroTipo &&
        this.validateCylinderFields.CodigoDesarrollo &&
        this.validateCylinderFields.CantidadCilindros
      );
    },
    async findAllDesarrolloCilindroTipoHTTP(params) {
      const result = await api.get(
        `/rel-desarrollo-cilindro-tipo?${getParamsUrl({ ...this.cylinderFilters, page: +this.page, limit: 50 })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.cylinderList.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findOneDesarrolloCilindroTipoHTTP(codigoCilindroTipo, codigoDesarrollo) {
      const result = await api.get(
        `/rel-desarrollo-cilindro-tipo/${codigoCilindroTipo}/${codigoDesarrollo}`,
      );
      if (result && result.data) {
        this.cylinder = result.data;
        return true;
      }
      return false;
    },
    async updateCylinderHTTP() {
      delete this.cylinder.CilindroTipo;
      delete this.cylinder.Desarrollo;
      const response = await api.patch(
        `/rel-desarrollo-cilindro-tipo/${this.cylinder.CodigoCilindroTipo}/${this.cylinder.CodigoDesarrollo}`,
        this.cylinder,
      );
      if (response.status === 200) {
        this.resetCilindros();
        return response;
      }
    },
    async newDesarrolloCilindroTipoHTTP() {
      const data = {
        CodigoCilindroTipo: this.cylinder.CodigoCilindroTipo,
        CodigoDesarrollo: this.cylinder.CodigoDesarrollo,
        CantidadCilindros: this.cylinder.CantidadCilindros,
        CantidadMagneticos: this.cylinder.CantidadMagneticos,
        CantidadAlmasStamping: this.cylinder.CantidadAlmasStamping,
        CantidadCilindrosRelieveEnLinea: this.cylinder.CantidadCilindrosRelieveEnLinea,
      };
      const response = await api.post('/rel-desarrollo-cilindro-tipo', data);
      if (response.status === 200 || response.status === 201) {
        this.resetCilindros();
        return response;
      } else {
        throw response;
      }
    },
    async firstCilindros() {
      this.setPage(1);
      this.emptyList();
      await this.findAllDesarrolloCilindroTipoHTTP();
    },
    resetCilindros() {
      this.cylinder = JSON.parse(JSON.stringify(initialCylinder));
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.cylinderList = [];
    },
    resetFilter() {
      this.cylinderFilters = { ...initial_filters };
    },
  },
});
